// Renders a visitor's chat message for an HTML context: the text is escaped,
// line breaks stay line breaks, and web addresses become links. Bot and agent
// messages are not passed through here; they are written with markup on purpose.
const escapeHtml = (value) =>
  String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const URL_PATTERN = /https?:\/\/[^\s<>"']+/g;

export const visitorMessageHtml = (value) => {
  const escaped = escapeHtml(value).replace(/&lt;br\s*\/?&gt;/gi, "<br>");
  return escaped.replace(URL_PATTERN, (url) => {
    const trailing = url.match(/[.,;:!?)]+$/);
    const clean = trailing ? url.slice(0, -trailing[0].length) : url;
    const rest = trailing ? trailing[0] : "";
    return `<a href="${clean}" target="_blank" rel="noopener noreferrer">${clean}</a>${rest}`;
  });
};
